import React from 'react';

function AvilaIcon({ className, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 29 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.4086 3.27066C20.2288 3.3156 20.0991 3.37892 19.9045 3.51658C19.5519 3.76615 19.585 3.70506 18.3025 6.46982C17.6691 7.83532 17.1448 8.9566 17.1373 8.96165C17.1298 8.96671 16.7671 8.1994 16.3312 7.25648C15.5355 5.53531 15.4358 5.33411 15.2988 5.17391C14.6625 4.42914 13.426 4.51121 12.9222 5.33158C12.8754 5.40792 12.4021 6.41022 11.8705 7.55896L10.904 9.64749L10.2311 8.19471C9.45038 6.50941 9.3527 6.35069 8.976 6.15656L8.88754 6.11095V5.39877C8.88754 4.77306 8.88299 4.68474 8.84995 4.67105C8.82923 4.66241 8.67943 4.65542 8.51703 4.65542H8.22171V5.31082V5.96629H8.11851C7.71765 5.96629 7.19226 6.2989 6.95489 6.7031C6.87745 6.83503 2.91895 15.3896 2.91895 15.4251C2.91895 15.4419 7.06731 15.4506 15.1296 15.4506C23.2389 15.4506 27.3403 15.442 27.3403 15.425C27.3403 15.3816 22.0939 4.05523 22.0161 3.93067C21.6909 3.40995 20.995 3.12422 20.4086 3.27066Z"
        fill="#A6A6A6"
      />
    </svg>
  );
}

export default AvilaIcon;
